import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "../../_css/UserProfileModal.module.css";
import _ from "lodash";
import { formatDate } from "../helper/formatters";

const UserProfileModal = ({ show, onHide, user }) => {
  if (!user) return null;
  return (
    <Modal
      style={{
        minWidth: "700px",
      }}
      show={show}
      onHide={onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="">User Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
          <div style={{ textAlign: "center", width: "40%" }}>
            <img
              src={
                user?.image_url ||
                "https://randomuser.me/api/portraits/women/44.jpg"
              }
              alt={user.fullName}
              style={{
                width: 140,
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: 16,
              }}
            />
            <h3 className={styles.profileInfoTitle}>{user.user_name}</h3>
            <div style={{ color: "#798797", fontSize: 16 }}>{user.email}</div>
          </div>
          <div className={styles.profileInfoPanel}>
            <h4 className={styles.profileInfoTitle}>Personal Info</h4>
            <table className={styles.profileInfoTable}>
              <tbody>
                <tr>
                  <td className={styles.profileInfoLabel}>Full Name</td>
                  <td className={styles.profileInfoValue}>: {user.user_name}</td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Email</td>
                  <td className={styles.profileInfoValue}>: {user.email}</td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Phone Number</td>
                  <td className={styles.profileInfoValue}>
                    : {user.phone_number}
                  </td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Designation</td>
                  <td className={styles.profileInfoValue}>
                    : {user.designation}
                  </td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Language</td>
                  <td className={styles.profileInfoValue}>: {user.language}</td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Join Date</td>
                  <td className={styles.profileInfoValue}>: {formatDate(user.date_joined)}</td>
                </tr>
                <tr>
                  <td className={styles.profileInfoLabel}>Subscription</td>
                  <td className={styles.profileInfoValue}>
                    :{" "}
                    <Button
                      variant="outline-info"
                      size="sm"
                      className={styles.profileInfoButton}
                      style={{ pointerEvents: "none" }}
                    >
                      {_.capitalize(user.sub_type)}
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UserProfileModal;
